import { useAutoResizeTextarea } from "../../../../../hooks/useAutoResizeTextarea";
import { getFaviconUrl } from "../../../../../utils/common/favicon/faviconUtils";
import LinkAddDialogSkeleton from "./Skeleton";

interface LinkAddDialogLinkNameProps {
  isFetching: boolean;
  debouncedValue: string;
  linkNameInput: string;
  handleLinkNameInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const LinkAddDialogLinkName = ({
  isFetching,
  debouncedValue,
  linkNameInput,
  handleLinkNameInputChange,
}: LinkAddDialogLinkNameProps) => {
  const {
    textareaRef,
    handleFocus,
    handleBlur,
    handleKeyDown,
    textareaStyles,
    handleResizeHeight,
  } = useAutoResizeTextarea(linkNameInput);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    handleLinkNameInputChange(e);
    setTimeout(() => {
      handleResizeHeight();
    }, 0);
  };

  const faviconUrl = getFaviconUrl(debouncedValue);

  return (
    <>
      <span className="text-[13px] font-normal text-white transition-opacity duration-300">
        Link name
      </span>
      <div className="flex w-full items-center gap-2 rounded-[5px] bg-[#252626] p-1.5 transition-all duration-300 focus-within:bg-5">
        {isFetching ? (
          <LinkAddDialogSkeleton />
        ) : (
          <>
            <img
              src={faviconUrl}
              alt="favicon"
              className="h-4 w-4 flex-shrink-0 items-center rounded-[5px]"
            />
            <textarea
              ref={textareaRef}
              className="flex-1 resize-none border-none bg-transparent text-[14px] font-normal text-white outline-none"
              value={linkNameInput}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
              rows={1}
              style={{
                minWidth: 0,
                ...textareaStyles,
              }}
            />
          </>
        )}
      </div>
    </>
  );
};

export default LinkAddDialogLinkName;
